import React from "react";

/**
 * Estados de bootstrap del local (slug / inactivo / no encontrado).
 * No reemplaza la carta; se muestra antes de cargar sucursales.
 */
export default function EstadoLocalPortal({ estado, slug, error }) {
  const titulo =
    estado === "cargando"
      ? "Cargando carta..."
      : estado === "sin_slug"
        ? "Elige un local"
        : estado === "inactivo"
          ? "Local no disponible"
          : estado === "error"
            ? "No se pudo cargar el local"
            : "Local no encontrado";

  const mensaje =
    estado === "cargando"
      ? "Estamos preparando la carta."
      : estado === "sin_slug"
        ? "Abre la carta con el enlace de tu local, por ejemplo /543 o /entregallos."
        : estado === "inactivo"
          ? "Este local no está activo en este momento."
          : estado === "error"
            ? error?.message ||
              "No pudimos conectar con el servidor. Intenta nuevamente."
            : slug
              ? `No existe un local con el identificador “${slug}”.`
              : "No encontramos este local.";

  return (
    <div
      className="container py-5"
      style={{
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        maxWidth: 520,
      }}
    >
      <div className="bg-white rounded-4 shadow px-4 py-5 text-center">
        <h1 className="fw-bold mb-3" style={{ fontSize: 28 }}>
          {titulo}
        </h1>
        <p className="text-muted mb-0">{mensaje}</p>
      </div>
    </div>
  );
}
